<div nz-row nzType="flex">
    <div nz-col nzSpan="8">
        <div class="formname">My Tasks</div>
    </div>
    <div nz-col nzSpan="8"></div>
    <div nz-col nzSpan="4" style="display: flex; justify-content: flex-end;">
        <form nz-form [nzLayout]="'inline'">
            <nz-form-item>
                <nz-date-picker nzAllowClear="false" name="date1111" nzFormat="dd/MM/yyyy" [(ngModel)]="ENQUIRY_DATE"
                    (ngModelChange)="loadAllProjects12($event)"> </nz-date-picker>
            </nz-form-item>

            <!-- <nz-form-item>
                <button   [hidden]="ADDSUB" nz-button nzType="primary" (click)="print()" nzJustify="end">
                    <i nz-icon nzType="plus"></i>Pick Task
                </button>
            </nz-form-item>          -->
        </form>
    </div>
    <div nz-col nzSpan="4" style="display: flex; justify-content: flex-end;">
        <form nz-form [nzLayout]="'inline'">
            <!-- <nz-form-item>
                <nz-date-picker nzAllowClear="false"  style="margin-left: -20px;width:40px" name="date1111" nzFormat="dd/MM/yyyy" [(ngModel)]="ENQUIRY_DATE"
                (ngModelChange)="loadAllProjects12($event)">    </nz-date-picker>
            </nz-form-item> -->

            <nz-form-item>
                <button [hidden]="ADDSUB" nz-button nzType="primary" (click)="print()" nzJustify="end">
                    <i nz-icon nzType="plus"></i>Pick Task
                </button>
            </nz-form-item>
        </form>
    </div>
</div>

<!-- <div nz-row>
    <div nz-col nzSpan="14">
        <div style="margin-left: 20px;" class="formname"> My Tasks</div>
    </div>
    <div nz-col nzSpan="5">
        <nz-form-item>
           
        
        </nz-form-item>
    </div>
    <div nz-col nzSpan="5">
        <nz-form-item>
           
        </nz-form-item>
    </div>
</div> -->
<nz-spin [nzSpinning]="isSpinning">

    <div style="padding-left: 5px; padding-right: 0px; margin-top: 10px;width: 72vw;
    overflow-x: scroll;   display: flex;">
        <!-- <div style="border: 1px solid grey ;border-radius: 9px;"> -->
        <!-- <div nz-col  nzSpan="24" > -->


        <!-- <ul nz-menu [nzMode]="'inline'">
                    <li nz-submenu style="color: #ff6161;border-radius: 6px;margin-top: 18px;
                    box-shadow: 0px 0px 10px #00000029;" nzTitle="Item Details"> -->
        <!-- <div > -->
        <!-- *ngFor="let items2 of projectList1;let k=index;" -->
        <div *ngFor="let items2 of projectList1;let k=index;" style="display: inline;width: 300px;margin-left: 10px;">
            <div style="border: 1px solid grey ;border-radius: 9px;margin-bottom:10px">
                <div class="example" id="cont" style="width: 300px; height: 460px;
                                overflow: hidden;margin-top: 10px;
                                overflow-y: scroll; padding:10px 10px !important;">

                    <!-- <div style="background-color: rgb(197, 202, 233);
                                    height: 10px;width: 100%;border-top-left-radius: 8px;
                                    border-top-right-radius: 8px;" nz-row>
                                    </div> -->
                    <!-- rgb(182, 178, 178); -->
                    <div nz-row>
                        <!-- <div nz-col nzSpan="24">
                                            <nz-form-item>
                                                <h3 style="color: #3c3c3d;margin-left: 10px;margin-top: 10px;align-content: center; "><b>{{items2.PROJECT_NAME}}</b></h3>
                                            </nz-form-item>
                                        </div> -->
                        <div nz-col nzSpan="21">
                            <nz-form-item>
                                <h4 style="color: #3c3c3d;margin-left: -10px;margin-top: -10px; ">
                                    <b>{{items2.PROJECT_NAME}}</b> > {{items2.MODULE_NAME}} > {{items2.FEATURE_NAME}} >
                                    {{items2.TASK_NAME}}
                                </h4>
                            </nz-form-item>
                        </div>
                        <div nz-col nzSpan="3">
                            <nz-form-item>
                                <button *ngIf="items2['TASKS'].length==0" nz-popconfirm
                                    nzPopconfirmTitle="Are you sure?" nzOkText="ok" nzCancelText="cancel"
                                    (nzOnConfirm)="confirm(items2)" (nzOnCancel)="cancel()"
                                    style="margin-top: -10px; margin-left: -10px; " nz-button nzType="default"
                                    nzShape="circle"><i nz-icon nzType="delete"></i></button>
                            </nz-form-item>
                        </div>
                        <!-- <div nz-col nzSpan="24">
                                            <nz-form-item>
                                                <h4 style="color: #3c3c3d;margin-left: 20px;margin-top: -10px;align-content: center; "><b> > {{items2.FEATURE_NAME}}</b></h4>
                                            </nz-form-item>
                                        </div>
                                        <div nz-col nzSpan="24">
                                            <nz-form-item>
                                                <h4 style="color: #3c3c3d;margin-left: 20px;margin-top: -10px;align-content: center; "><b> > {{items2.TASK_NAME}}</b></h4>
                                            </nz-form-item>
                                        </div> -->

                        <!-- <div nz-col nzSpan="6">
                                            <h5 style="color:#1890ff;margin-top: 15px;margin-left:-6px;cursor: pointer;" (click)="addcustomer(items2)"  >+ Add Task
                                            </h5>

                                        </div> -->
                    </div>
                    <div nz-row>
                        <div nz-col nzSpan="12">
                            <h4 style="text-align: left;color: rgb(248, 170, 52);">Subtasks </h4>
                        </div>
                        <div [hidden]="ADDSUB" nz-col nzSpan="12">
                            <h4 (click)="print1(items2)" style="text-align: right;margin-right: 5px; cursor: pointer;">
                                + Add Subtask
                            </h4>
                        </div>
                    </div>
                    <!-- <div nz-row class="example"
                                    [nzGutter]="8"> -->
                    <!-- *ngFor="let items of items2['TASKS'];let j=index;" (click)="edit1(items)" -->
                    <!-- onmouseover="this.style.background='#E2F2FF',this.style.border='1px solid blue',this.style.cursor='pointer';" onmouseout="this.style.background='white',this.style.border='1px solid grey';" -->
                    <nz-spin [nzSpinning]="isSpinninggg">
                        <div *ngFor="let items of items2['TASKS'];let j=index;" class="divide">
                            <div nz-row>
                                <!-- <div nz-col nzSpan="24">
                                    <nz-form-item>
                                        <h4 style="color: #3c3c3d;margin-top: 10px;align-content: center;">
                                            {{items.NAME}}</h4>
                                    </nz-form-item>
                                </div> -->
                                <div nz-col nzSpan="24">
                                    <div>
                                        <h4>
                                            <p style="color: #3c3c3d;margin-top: 10px;align-content: center;margin-left: 5%;width: 90%;"
                                                nz-typography nzEditable [(nzContent)]="items.NAME"
                                                (nzContentChange)="onContentNameChange($event,items)"></p>
                                        </h4>
                                    </div>
                                </div>

                                <div *ngIf="items.PRIORITY=='H'" nz-col nzSpan="10">
                                    <div nz-row>
                                        <select [(ngModel)]="items.PRIORITY" style="margin-left:10px;margin-top:-2px;border: 1px solid red;
                                            height: 29px;
                                            text-align: center;                                           
                                            border-radius: 9px; " (ngModelChange)="radiodropChange($event,items)">
                                            <option [value]="'H'">High </option>
                                            <option [value]="'M'">
                                                <h4>Medium</h4>
                                            </option>
                                            <option [value]="'L'">
                                                <h4>Low</h4>
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div *ngIf="items.PRIORITY=='M'" nz-col nzSpan="10">
                                    <div nz-row>
                                        <select [(ngModel)]="items.PRIORITY" style="margin-left:10px;margin-top:-2px;border: 1px solid rgb(63, 136, 245);
                                        height: 29px;
                                        text-align: center;                                           
                                        border-radius: 9px; " (ngModelChange)="radiodropChange($event,items)">
                                            <option [value]="'H'">High </option>
                                            <option [value]="'M'">
                                                <h4>Medium</h4>
                                            </option>
                                            <option [value]="'L'">
                                                <h4>Low</h4>
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div *ngIf="items.PRIORITY=='L'" nz-col nzSpan="10">
                                    <div nz-row>
                                        <select [(ngModel)]="items.PRIORITY" style="margin-left:10px;margin-top:-2px;border: 1px solid rgb(68, 247, 68);
                                    height: 29px;
                                    text-align: center;                                           
                                    border-radius: 9px; " (ngModelChange)="radiodropChange($event,items)">
                                            <option [value]="'H'">High </option>
                                            <option [value]="'M'">
                                                <h4>Medium</h4>
                                            </option>
                                            <option [value]="'L'">
                                                <h4>Low</h4>
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <!-- <div nz-col nzSpan="10">
                                                <div nz-row>
                                                    <div nz-col nzSpan="24">
                                                      
                                                        <h4 style="text-align: left;margin-left: 20px; color: #f5222d;" *ngIf="items.PRIORITY=='H'">High <span nz-icon nzType="edit" style="color: black;" nzTheme="outline">
                                                        </span></h4>
                                                     
                                                    </div>
                                                    <div nz-col nzSpan="24">
                                                        
                                                        <h4 style="text-align: left;margin-left: 20px;color: #639ef7;" *ngIf="items.PRIORITY=='M'">Medium <span nz-icon nzType="edit" style="color: black;" nzTheme="outline"></span></h4>
                                                        
                                                    </div>
                                                    <div nz-col nzSpan="24">
                                                        
                                                        <h4 style="text-align: left;margin-left: 20px;color: #52c41a;" *ngIf="items.PRIORITY=='L'">Low <span nz-icon nzType="edit" style="color: black;" nzTheme="outline"></span></h4>
                                                     
                                                    </div>
                                                </div>
                                            </div> -->
                                <!-- <div nz-col nzSpan="1"><span nz-icon nzType="edit" nzTheme="outline"></span></div> -->
                                <!-- <nz-form-item>
                                                  
                                                    <nz-input-group>
                                                        <nz-form-control  nzErrorTip="Please Select Priority ">
                                                            <nz-select nzShowSearch nzAllowClear name="PRIORITY"  style="width: 100%;"
                                                                nzPlaceHolder="Select Priority" [(ngModel)]="items.PRIORITY">
                                                                <nz-option [nzValue]="'H'" [nzLabel]="'High'"></nz-option>
                                                                <nz-option [nzValue]="'M'" [nzLabel]="'Medium'" ></nz-option>
                                                                <nz-option [nzValue]="'L'" [nzLabel]="'Low'" ></nz-option>
                                                              
                                                            </nz-select>
                                                        </nz-form-control>
                                                    </nz-input-group>
                                                </nz-form-item> -->

                                <!-- <div nz-col nzSpan="3"></div> -->
                                <div [hidden]="ADDSUB1" nz-col nzSpan="12">

                                    <!-- <div style="height: 23px;margin-left: 8px; width: 60px; border-radius:5px;margin-top: -5px; background-color: rgb(169, 253, 175);"> -->
                                    <h4 (click)="print21(items)" style="text-align: right;cursor: pointer;">Worklogs
                                        <span nz-icon nzType="appstore-add" nzTheme="outline"></span>
                                    </h4>
                                    <!-- </div> -->

                                    <!-- <nz-form-item>                                                
                                                    <nz-input-group>
                                                        <nz-form-control  nzErrorTip="Please Select Progress ">
                                                           <nz-input-number disabled name="Progress" maxlength="100" [nzFormatter]="formatterPercent" [(ngModel)]="items.PROGRESS"  style="width:100%;"
                                                           nzPlaceHolder="Enter Progress"></nz-input-number>
                                                        </nz-form-control>
                                                    </nz-input-group>
                                                </nz-form-item> -->
                                </div>
                                <div nz-col nzSpan="19">
                                    <nz-form-item>
                                        <nz-progress style="margin-left:10px;height:70px !important;"
                                            [nzPercent]="items.PROGRESS" [nzShowInfo]="false"
                                            nzStrokeColor="rgb(248, 170, 52)">
                                        </nz-progress>
                                    </nz-form-item>
                                </div>
                                <div nz-col nzSpan="5">
                                    <nz-form-item>
                                        {{items.PROGRESS}}%
                                        <!-- <nz-progress style="margin-left:10px; " [nzPercent]="100"  [nzShowInfo]="false" [nzStrokeColor]="{ '0%': 'rgb(245, 135, 120)', '100%': 'rgb(127, 252, 125)' }"></nz-progress> -->
                                        <!-- <nz-progress style="margin-left:10px; "  [nzPercent]="100" [nzSteps]="5" nzStrokeColor="#1890ff"></nz-progress> -->
                                    </nz-form-item>
                                </div>
                                <!-- <button type="button"  (click)="print21(items)" style="margin-left:31%;margin-top: 10px;" class="ant-btn ant-btn-primary" nz-button ><span>Add Log</span></button> -->

                            </div>
                            <!-- <div nz-row >
                                            <div nz-col nzSpan="12">
                                        <div nz-row >
                                            <div nz-col nzSpan="24">
                                                <nz-form-item>
                                                    <h4 style="color: #858586;align-content: center;">Priority</h4>
                                                </nz-form-item>
                                            </div>
                                        </div>
    
                                        <div nz-row>
                                            <div *ngIf="items.PRIORITY=='H'" nz-col nzSpan="24">
                                                <div style="height: 23px;margin-left: 18px; width: 60px; border-radius:5px;margin-top: -5px; background-color:  rgb(255 137 137);">
                                                <h4 style="text-align: center;margin-bottom: 2px;">High</h4>
                                                </div>
                                            </div>
                                            <div *ngIf="items.PRIORITY=='M'" nz-col nzSpan="24">
                                                <div style="height: 23px;margin-left: 18px; width: 70px; border-radius:5px;margin-top: -5px; background-color: rgb(197, 215, 248);">
                                                <h4 style="text-align: center;margin-bottom: 2px;">Medium</h4>
                                                </div>
                                            </div>
                                            <div *ngIf="items.PRIORITY=='L'" nz-col nzSpan="24">
                                                <div style="height: 23px;margin-left: 18px; width: 60px; border-radius:5px;margin-top: -5px; background-color: rgb(204, 250, 207);">
                                                <h4 style="text-align: center;margin-bottom: 2px;">Low</h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div nz-col nzSpan="12">
                                        <div nz-row >
                                            <div nz-col nzSpan="24">
                                                <nz-form-item>
                                                    <h4 style="color: #858586;align-content: center;">Status</h4>
                                                </nz-form-item>
                                            </div>
                                        </div>
    
                                        <div nz-row>
                                            <div nz-col *ngIf="items.STATUS=='P'" nzSpan="24">
                                                <div style="height: 23px;margin-left: 18px; width: 65px; border-radius:5px;margin-top: -5px; background-color: rgb(247, 210, 210);">
                                                <h4 style="text-align: center;margin-bottom: 2px;">Pending</h4>
                                                </div>
                                            </div>
                                            <div nz-col *ngIf="items.STATUS=='I'" nzSpan="24">
                                                <div style="height: 23px;margin-left: 18px; width: 80px; border-radius:5px;margin-top: -5px; background-color: rgb(197, 215, 248);">
                                                <h4 style="text-align: center;margin-bottom: 2px;">Incomplete</h4>
                                                </div>
                                            </div>
                                            <div nz-col *ngIf="items.STATUS=='N'" nzSpan="24">
                                                <div style="height: 23px;margin-left: 18px; width: 80px; border-radius:5px;margin-top: -5px; background-color: rgb(197, 215, 248);">
                                                <h4 style="text-align: center;margin-bottom: 2px;">Inprocess</h4>
                                                </div>
                                            </div>
                                            <div nz-col *ngIf="items.STATUS=='C'" nzSpan="24">
                                                <div style="height: 23px;margin-left: 18px; width: 90px; border-radius:5px;margin-top: -5px; background-color:  rgb(204, 250, 207);">
                                                <h4 style="text-align: center;margin-bottom: 2px;">Completed</h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                           </div> -->
                            <!-- <div nz-row >
                                            <div nz-col nzSpan="24">
                                                <nz-form-item>
                                                    <h4 style="color: #858586;align-content: center;margin-top: 10px;">Progress: </h4>
                                                </nz-form-item>
                                            </div>
                                        </div> 
                                         -->
                            <!-- <div nz-row >
                                            <div style="margin-top:-13px" nz-col nzSpan="19">
                                                <nz-form-item>
                                                    <nz-progress style="margin-left:10px; " [nzPercent]="items.COMPLETION_PERCENTAGE" [nzShowInfo]="false" [nzStrokeColor]="{ '0%': 'rgb(197, 215, 248)', '100%': 'rgb(204, 250, 207);' }"></nz-progress>
                                                  
                                                </nz-form-item>
                                            </div>
                                            <div style="margin-top:-13px" nz-col nzSpan="4">
                                                <nz-form-item>
                                                    {{items.COMPLETION_PERCENTAGE}}%
                                                 
                                                </nz-form-item>
                                            </div>
                                        </div> -->

                            <!-- <div nz-row >
                                            <div nz-col nzSpan="24">
                                                <nz-form-item>
                                                    <h4 style="color: #858586;align-content: center;">Taken Date</h4>
                                                    <h4 *ngIf="items.TAKEN_DATE!=null" style="color: #3c3c3d;align-content: center;margin-top:-5px;margin-left: 15px;"><b>{{items.TAKEN_DATE}}</b></h4>
                                                    <h4 *ngIf="items.TAKEN_DATE==null" style="color: #3c3c3d;align-content: center;margin-top:-5px;margin-left: 15px;"><b>-</b></h4>
                                                </nz-form-item>
                                            </div>
                                        </div>
                                        <div nz-row >
                                            <div nz-col nzSpan="24">
                                                <nz-form-item>
                                                    <h4 style="color: #858586;align-content: center;">Completed Date</h4>
                                                    <h4 *ngIf="items.COMPLETED_DATE!=null" style="color: #3c3c3d;align-content: center;margin-top:-5px;margin-left: 15px;"><b>{{items.COMPLETED_DATE}}</b></h4>
                                                    <h4 *ngIf="items.COMPLETED_DATE==null" style="color: #3c3c3d;align-content: center;margin-top:-5px;margin-left: 15px;"><b>-</b></h4>
                                                
                                                </nz-form-item>
                                            </div>
                                        </div> -->



                        </div>
                    </nz-spin>

                    <!-- </div> -->
                    <!-- <div style="background-color: rgb(197, 202, 233);
                                height: 30px;width: 100%;border-bottom-left-radius: 8px;
                                border-bottom-right-radius: 8px;margin-top: 8px;" nz-row><h4 (click)="print1(items2)" style="margin-left: 90px;margin-top: 4px;cursor: pointer;">+ Add Subtask</h4>
                                </div> -->
                </div>
            </div>
        </div>
        <!-- </div> -->
        <!-- </li>
                </ul> -->

        <!-- </div> -->

        <!-- </div> -->
    </div>
</nz-spin>

<div *ngIf="drawerVisible1">
    <nz-drawer [nzBodyStyle]="{ height: 'calc(100% - 55px)', overflow: 'auto', 'padding-bottom': '53px' }"
        [nzClosable]="true" [nzMask]="true" [nzMaskClosable]="false" [nzWidth]="660" [nzVisible]="drawerVisible1"
        [nzTitle]="drawerTitle1" (nzOnClose)="drawerClose1()" (nzKeyboard)="true">
        <ng-container *nzDrawerContent>
            <!-- <app-addtask [drawerClose1]="closeCallback1" [data]="drawerData1">
        </app-addtask> -->
        </ng-container>
    </nz-drawer>
</div>

<div [hidden]="glass"
    style="margin-left:340px;margin-top:120px;padding-top: 10px;padding-left: 30px; width: 300px;height:50px;border:2px solid rgb(248, 170, 52);border-radius: 9px;">
    <h3>You Have Not Taken Any Task</h3>
</div>
<!-- pick task Done -->
<nz-modal [(nzVisible)]="isVisible2" nzClosable="false" nzMaskClosable="false" nzWidth="760px"
    (nzOnOk)="handlePrintforpick(true)" (nzOnCancel)="handleCancel()">
    <ng-container *nzModalContent>
        <button printSectionId="print-section" #idprint style="display: none;" ngxPrint></button>

        <div id="print-section">
            <div #content id="content" style="padding-left: 7px;background: #fff;" class="print-container">
                <div nz-row>
                    <div nz-row style="overflow-y: auto; overflow-x: hidden; height: 155px;">

                        <div nz-col nzSpan="24">
                            <div>
                                <div nz-row>
                                    <div nz-col nzSpan="12">
                                        <nz-form-item>
                                            <nz-form-label nzRequired nzNoColon>Project</nz-form-label>

                                            <nz-form-control>
                                                <nz-select name="projectName" nzShowSearch [nzLoading]="isListLoading"
                                                    nzPlaceHolder="Select a Project" [(ngModel)]="data1.PROJECT_ID"
                                                    (ngModelChange)="radioButtonChange()">

                                                    <!-- <span
                                            *ngIf="this.cookie.get('level') == '1' || this.cookie.get('level') == '2' || this.cookie.get('level') == '3'">
                                            <nz-option  *ngFor="let project of projectList" [nzValue]="project.ID" [nzLabel]="project.NAME">
                                            </nz-option>
                                          </span> -->

                                                    <!-- <span> -->
                                                    <nz-option *ngFor="let project of projectList"
                                                        [nzValue]="project.PROJECT_ID" [nzLabel]="project.NAME">
                                                    </nz-option>
                                                    <!-- </span> -->
                                                </nz-select>
                                            </nz-form-control>
                                        </nz-form-item>
                                    </div>
                                    <div nz-col nzSpan="12">
                                        <nz-form-item>
                                            <nz-form-label nzRequired nzNoColon>Module</nz-form-label>

                                            <nz-form-control>
                                                <nz-select name="subtaskModuleName" nzShowSearch nzAllowClear
                                                    [nzLoading]="isSubtaskModuleLoading" nzPlaceHolder="Select a Module"
                                                    (ngModelChange)="fillSubtaskFeatureModuleWise($event)"
                                                    [(ngModel)]="data1.SUBTASK_MODULE_ID">
                                                    <nz-option *ngFor="let module of moduleList" [nzValue]="module.ID"
                                                        [nzLabel]="module.NAME">
                                                    </nz-option>
                                                </nz-select>
                                            </nz-form-control>
                                        </nz-form-item>
                                    </div>

                                    <div nz-col nzSpan="12">
                                        <nz-form-item>
                                            <nz-form-label nzRequired nzNoColon>Feature</nz-form-label>

                                            <nz-form-control>
                                                <nz-select name="subtaskFeatureName" nzShowSearch nzAllowClear
                                                    [nzLoading]="isSubtaskFeatureLoading"
                                                    nzPlaceHolder="Select a Feature"
                                                    (ngModelChange)="fillTaskSubtaskFeatureWise($event)"
                                                    [(ngModel)]="data1.SUBTASK_FEATURE_ID">
                                                    <nz-option *ngFor="let feature of subtaskFeatureList"
                                                        [nzValue]="feature.ID" [nzLabel]="feature.NAME">
                                                    </nz-option>
                                                </nz-select>
                                            </nz-form-control>
                                        </nz-form-item>
                                    </div>

                                    <div nz-col nzSpan="12">
                                        <nz-form-item>
                                            <nz-form-label nzRequired nzNoColon>Parent Task</nz-form-label>

                                            <nz-form-control>
                                                <nz-select name="parentTask" nzShowSearch nzAllowClear
                                                    [nzLoading]="isSubtaskParentTaskLoading"
                                                    nzPlaceHolder="Select a Parent Task"
                                                    [(ngModel)]="data1.PARENT_TASK_ID"
                                                    (ngModelChange)="fillTaskSubtaskWise($event)">
                                                    <nz-option *ngFor="let task of parentTaskList" [nzValue]="task.ID"
                                                        [nzLabel]="task.NAME">
                                                    </nz-option>
                                                </nz-select>
                                            </nz-form-control>
                                        </nz-form-item>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
    <div *nzModalFooter>
        <button nz-button nzType="default" (click)="handleCancel()">Close</button>
        <button nz-button nzType="primary" (click)="handlePrintforpick(true)"
            [nzLoading]="isConfirmLoading2">Pick</button>
    </div>
</nz-modal>

<!-- add subtask -->
<nz-modal [(nzVisible)]="isVisible23" nzClosable="false" nzMaskClosable="false" nzWidth="360px"
    (nzOnOk)="handleaddsubtask(true)" (nzOnCancel)="handleCancel1()">
    <ng-container *nzModalContent>
        <button printSectionId="print-section" #idprint style="display: none;" ngxPrint></button>

        <div id="print-section">
            <div #content id="content1" style="padding-left: 7px;background: #fff;" class="print-container">
                <div nz-row>

                    <div nz-row style=" height: 185px;">

                        <div nz-row>
                            <div nz-col nzSpan="24">
                                <nz-form-item>
                                    <nz-form-label nzNoColon>Add Sub-Task</nz-form-label>
                                    <nz-form-control nzHasFeedback nzErrorTip="Please Enter Your Task">
                                        <textarea style="width: 100%;" nz-input rows="2"
                                            placeholder="Please Enter Your Task" maxlength="2048" name="moc"
                                            [(ngModel)]="SUBTASK"></textarea>
                                    </nz-form-control>
                                    <small *ngIf="SUBTASK!=undefined">{{SUBTASK.length}}/2048</small>
                                </nz-form-item>
                            </div>
                            <div nz-col nzSpan="12">
                                <nz-form-item>
                                    <nz-form-label nzNoColon>Priority </nz-form-label>
                                    <nz-input-group>
                                        <nz-form-control nzErrorTip="Please Select Priority ">
                                            <nz-select nzShowSearch nzAllowClear name="PRIORITY" style="width: 80%;"
                                                nzPlaceHolder="Select Priority" [(ngModel)]="data5.PRIORITY">
                                                <nz-option [nzValue]="'H'" [nzLabel]="'High'"></nz-option>
                                                <nz-option [nzValue]="'M'" [nzLabel]="'Medium'"></nz-option>
                                                <nz-option [nzValue]="'L'" [nzLabel]="'Low'"></nz-option>

                                            </nz-select>
                                        </nz-form-control>
                                    </nz-input-group>
                                </nz-form-item>
                            </div>
                        </div>

                    </div>
                </div>


            </div>
        </div>
    </ng-container>
    <div *nzModalFooter>
        <button nz-button nzType="default" (click)="handleCancel1()">Close</button>
        <button nz-button nzType="primary" (click)="handleaddsubtask(true)" [nzLoading]="isConfirmLoading1">Add</button>
    </div>
</nz-modal>

<!-- add log  -->
<nz-modal [(nzVisible)]="isVisible234" nzOkText="Add" nzClosable="false" nzMaskClosable="false" nzCancelText="Cancel"
    nzWidth="600px" (nzOnCancel)="handleCancel12()">
    <ng-container *nzModalContent>
        <button printSectionId="print-section" #idprint style="display: none;" ngxPrint></button>

        <div id="print-section">
            <div #content id="content12" style="padding-left: 7px;background: #fff;" class="print-container">
                <div nz-row>

                    <div nz-row style="overflow-y: auto; overflow-x: hidden; height: 200px;">

                        <div nz-row>


                            <div nz-col nzSpan="6">
                                <nz-form-item>
                                    <nz-form-label nzRequired nzNoColon>Start Date Time</nz-form-label>

                                    <nz-form-control>
                                        <nz-date-picker style="width: 100%;" name="updatedDate" nzShowTime
                                            [nzDisabledDate]="disabledStartDate" [nzShowTime]="{ nzFormat: 'hh:mm a' }"
                                            nzFormat="hh:mm a" [(ngModel)]="data6.WORKED_DATETIME"
                                            (nzOnOpenChange)="moduleStartDateHandle($event)"
                                            (ngModelChange)="startDateChange()">
                                        </nz-date-picker>
                                    </nz-form-control>
                                </nz-form-item>
                            </div>

                            <div nz-col nzSpan="6">
                                <nz-form-item>
                                    <nz-form-label nzRequired nzNoColon>End Date Time</nz-form-label>

                                    <nz-form-control>
                                        <nz-date-picker #moduleEndDatePicker style="width: 100%;" name="endDate"
                                            nzShowTime [nzDisabledDate]="disabledEndDate"
                                            [nzShowTime]="{ nzFormat: 'hh:mm a' }" nzFormat="hh:mm a"
                                            [(ngModel)]="data6.END_DATETIME"
                                            (nzOnOpenChange)="moduleEndDateHandle($event)"
                                            (ngModelChange)="endDateChange()">
                                        </nz-date-picker>
                                    </nz-form-control>
                                </nz-form-item>
                            </div>

                            <div nz-col nzSpan="6">
                                <nz-form-item>
                                    <nz-form-label nzNoColon>Time Spent</nz-form-label>

                                    <nz-form-control>
                                        <b><span>{{data6.SPENT_HOURS}}h {{data6.SPENT_MINUTES}}m
                                                {{data6.SPENT_SECONDS}}s</span></b>
                                    </nz-form-control>

                                    <!-- <div style="display: inline-flex;">
                                    <nz-form-control nzErrorTip="Hours is Required">
                                        <input nz-input name="spentHours" type="number" min="0"
                                            oninput="this.value = Math.abs(this.value)" placeHolder="HH"
                                            [(ngModel)]="data.SPENT_HOURS" required />
                                    </nz-form-control>
            
                                    <nz-form-control nzErrorTip="Minutes is Required">
                                        <input nz-input name="spentMinutes" type="number" min="0"
                                            oninput="this.value = Math.abs(this.value)" placeHolder="MM"
                                            [(ngModel)]="data.SPENT_MINUTES" required />
                                    </nz-form-control>
            
                                    <nz-form-control nzErrorTip="Seconds is Required">
                                        <input nz-input name="spentSeconds" type="number" min="0"
                                            oninput="this.value = Math.abs(this.value)" placeHolder="SS"
                                            [(ngModel)]="data.SPENT_SECONDS" required />
                                    </nz-form-control>
                                </div> -->
                                </nz-form-item>
                            </div>
                            <div nz-col nzSpan="6">
                                <nz-form-item>
                                    <nz-form-label nzNoColon>Progress % </nz-form-label>
                                    <nz-input-group>
                                        <nz-form-control nzErrorTip="Please Select Progress ">
                                            <nz-input-number name="Progressss" [(ngModel)]="data6.PROGRESS" [nzMin]="1"
                                                [nzFormatter]="formatterPercent" [nzMax]="100" style="width:100%;"
                                                nzPlaceHolder="Enter Progress"></nz-input-number>
                                        </nz-form-control>
                                    </nz-input-group>
                                </nz-form-item>
                            </div>
                            <div nz-col nzSpan="24">
                                <nz-form-item>
                                    <nz-form-label nzNoColon>Description</nz-form-label>
                                    <nz-form-control nzHasFeedback nzErrorTip="Please Enter Description">
                                        <textarea nz-input rows="2" placeholder="Please Enter Description"
                                            maxlength="2048" name="msoc"
                                            [(ngModel)]="data6.WORK_DESCRIPTION"></textarea>
                                    </nz-form-control>
                                    <small
                                        *ngIf="data6.WORK_DESCRIPTION!=undefined">{{data6.WORK_DESCRIPTION.length}}/2048</small>
                                </nz-form-item>
                            </div>
                            <!-- <div nz-col nzSpan="12" *ngIf="estimatedTime_Mandays== 'T'">
                            <nz-form-item>
                                <nz-form-label nzNoColon>Estimated Time</nz-form-label>
            
                                <nz-form-control>
                                    <b><span>{{estimatedHH}}h {{estimatedMM}}m {{estimatedSS}}s</span></b>
                                </nz-form-control>
                            </nz-form-item>
                        </div>
            
                        <div nz-col nzSpan="12" *ngIf="estimatedTime_Mandays== 'M'">
                            <nz-form-item>
                                <nz-form-label nzNoColon>Estimated Mandays</nz-form-label>
            
                                <nz-form-control>
                                    <b><span>{{estimatedMandays}}</span></b>
                                </nz-form-control>
                            </nz-form-item>
                        </div> -->
                        </div>

                    </div>
                </div>


            </div>
        </div>
        <div nz-row class="example1" [nzGutter]="8">
            <!-- *ngFor="let itemss of items2['TASKS'];let b=index;"{{itemss.WORK_DESCRIPTION}} -->
            <div nz-col nzSpan="24">
                <h4 style="text-align: left;color: rgb(248, 170, 52);">Worklogs </h4>
            </div>
            <div nz-col nzSpan="24">
                <nz-empty [hidden]="empty"></nz-empty>
            </div>


            <nz-timeline *ngIf="worklogData1.length>0" style="margin-left: 20px;width:100%;">
                <nz-timeline-item nzColor="blue" [nzDot]="dotTemplate" *ngFor="let itemss of worklogData1;let b=index;">
                    <div class="my-box1" style="height: 90%;width:90%;margin-left: 5%;">
                        <div nz-row>
                            <!-- <div nz-col nzSpan="24">
             <nz-form-item>
             <h4 style="color: #3c3c3d;margin-top: 10px;align-content: center;"><b>{{itemss.WORK_DESCRIPTION}}</b></h4>
            </nz-form-item>
                      </div> -->
                            <div nz-col nzSpan="24">
                                <!-- <b>Description : </b><br> -->
                                <h3 style="color: white !important;margin-bottom:1px"> {{itemss.WORK_DESCRIPTION}}</h3>
                            </div>

                            <!-- <button nz-button nzType="primary" nz-popover nzPopoverTitle="Title"
                                [(nzPopoverVisible)]="visible" (nzPopoverVisibleChange)="change($event)"
                                nzPopoverTrigger="click" [nzPopoverContent]="contentTemplate">
                                Click me
                            </button> -->
                            <!-- <ng-template #contentTemplate{{b}}>
                                <div nz-row>
                                    <div nz-col nzSpan="24">
                                        <a (click)="clickMe(itemss)">Edit</a>
                                    </div>
                                </div>
                               
                                <div nz-row>
                                    <div nz-col nzSpan="24">
                                        <a (click)="clickMe()">Delete</a>
                                    </div>
                                </div>
                             
                              
                            </ng-template> -->
                            <!-- <div nz-col nzSpan="1"></div>   -->
                            <div nz-col nzSpan="18" style="font-size:11px">
                                <!-- <b>Start Date Time : </b><br> -->
                                {{itemss.START_DATETIME | date: 'dd MMM, yyyy hh:mm a'}} - {{itemss.END_DATETIME | date:
                                ' hh:mm a'}} ( {{ itemss.SPENT_HOURS + "h " + itemss.SPENT_MINUTES + "m " +
                                itemss.SPENT_SECONDS + "s "}} )
                            </div>
                            <div nz-col nzSpan="3">
                                <a style="color: white;" (click)="clickMe(itemss)">Edit </a>
                            </div>
                            <div nz-col nzSpan="3">
                                <!-- <a style="color: white;">Delete</a> -->
                                <a style="color: gray;" nz-popconfirm
                                    nzPopconfirmTitle="Are you sure delete this Worklog?" nzPopconfirmPlacement="bottom"
                                    (nzOnConfirm)="handleConfirmForWorklog(itemss)"
                                    (nzOnCancel)="handleCancelForWorklog()" style="color: white;">
                                    Delete
                                </a>
                            </div>
                            <!-- <div nz-col nzSpan="2"></div>                                                    
<div nz-col nzSpan="10"> -->
                            <!-- <b>End Date Time : </b><br> -->
                            <!-- {{itemss.END_DATETIME | date: 'dd MMM, yyyy hh:mm a'}}
</div>      #37b9ad
<div nz-col nzSpan="1"></div>   -->
                            <!-- <nz-divider nzText=""></nz-divider> -->

                            <!-- <div nz-col nzSpan="24">
<b>Spent Time : </b><br>
{{ itemss.SPENT_HOURS + "h " + itemss.SPENT_MINUTES + "m " + itemss.SPENT_SECONDS + "s "}}
</div> -->

                            <!-- <nz-divider nzText=""></nz-divider> -->


                            <!-- <button type="button"  (click)="print21()" style="margin-left:31%;margin-top: 10px;" class="ant-btn ant-btn-primary" nz-button ><span>Add Log</span></button> -->

                        </div>

                    </div>
                </nz-timeline-item>
                <ng-template #dotTemplate>
                    <span nz-icon nzType="clock-circle-o" style="font-size: 16px;"></span>
                </ng-template>
            </nz-timeline>



        </div>
    </ng-container>
    <div *nzModalFooter>
        <button nz-button nzType="default" (click)="handleCancel12()">Close</button>
        <button nz-button nzType="primary" *ngIf="!data6.ID" (click)="handlePrint1(true)"
            [nzLoading]="isConfirmLoading">Add</button>
        <button nz-button nzType="primary" *ngIf="data6.ID" (click)="handlePrint1(true)"
            [nzLoading]="isConfirmLoading">Update</button>
    </div>
</nz-modal>